<template>
  <div>
    <v-list-item :disabled="disabled">
      <slot name="rowIconsLeft"/>

      <v-list-item-avatar v-if="hasImage" class="me-9">
        <v-img :src="image"/>
      </v-list-item-avatar>

      <v-list-item-content @click="$emit('click-content')" class="dynameat-row-content" :class="{clickable: isClickable, 'center-title': centerTitle}">
        <v-col>
          <v-list-item-title v-text="title" @click="onTitleClick" :class="{'center-title': centerTitle}"/>
          <v-list-item-subtitle v-if="description && !descriptionClickable" v-text="description"/>
          <v-list-item-subtitle v-if="description && descriptionClickable" v-text="description"
                                @click="onDescriptionClick" class="text-decoration-underline"/>
          <slot name="aboveContent"/>
        </v-col>
        <slot name="middleContent"/>
      </v-list-item-content>

      <slot name="rowIconsRight"/>

      <div v-if="!collapseItems">
        <v-list-item-action class="mx-0" v-for="button in buttonConfigList" :key="button.title"
                            @click="$emit(button.emitName)">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-on="on" v-bind="attrs" :disabled="!!button.disabled">
                <v-icon color="grey"> {{ button.icon }}</v-icon>
              </v-btn>
            </template>
            <span>{{ button.title }}</span>
          </v-tooltip>
        </v-list-item-action>
      </div>
      <v-menu v-else offset-y>
        <template v-slot:activator="{ on }" v-if="buttonConfigList.length !== 0">
          <v-btn icon v-on="on">
            <v-icon dense>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="button in buttonConfigList" :key="button.title" @click="$emit(button.emitName)">
            <v-list-item-content>
              <v-list-item-title>{{ button.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>
    <v-divider v-if="hasDivider" v-bind:class="{ 'strong-divider': strongDivider }"/>
  </div>
</template>

<script>

import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import Vue from 'vue';

@Component
export default class DynameatRow extends Vue {
    @Prop({ Boolean, default: false }) hasImage;

    // eslint-disable-next-line global-require
    @Prop({ Boolean, default: require('../assets/images/dynameat-logo-primary.png') }) image;

    @Prop({ String, default: '' }) title;

    @Prop({ default: '' }) description;

    @Prop({ Boolean, default: false }) descriptionClickable;

    @Prop({ Boolean, default: false }) disabled;

    @Prop({ Boolean, default: true }) isClickable;

    @Prop({ Boolean, default: false }) strongDivider;

    @Prop({ Boolean, default: false }) centerTitle;

    @Prop({ Boolean, default: true }) hasDivider;

    @Prop({ Boolean, default: false }) collapseItems;

    @Prop({
      Array,
      default: () => [],
      validator: (list = []) => list.every((buttonConfig) => buttonConfig.title
        && buttonConfig.icon
        && buttonConfig.emitName),
    }) buttonConfigList;

    onDescriptionClick(event) {
      event.stopPropagation();
      this.$emit('description-click');
    }

    onTitleClick() {
      this.$emit('title-click');
    }
}
</script>
<style scoped>
.clickable:hover {
  transform: scale(1.00);
  font-weight: bolder;
  cursor: pointer;
}

.strong-divider{
  border-color: darkgrey !important;
}

.center-title{
  margin: auto;
  width: fit-content;
}
</style>
